import { combineReducers } from 'redux';
import booking, { initialState as bookingInitialState } from '@/ducks/booking/bookingReducer';
import object, { initialState as objectInitialState } from '@/ducks/object/objectReducer';
import order, { initialState as orderInitialState } from '@/ducks/order/orderReducer';
import price, { initialState as priceInitialState } from '@/ducks/price/priceReducer';
import profile, { initialState as profileInitialState } from '@/ducks/profile/profileReducer';
import results, { initialState as resultsInitialState } from '@/ducks/results/resultsReducer';

export const initialState = {
    results: resultsInitialState,
    objectData: objectInitialState,
    profileData: profileInitialState,
    orderData: orderInitialState,
    bookingData: bookingInitialState,
    priceData: priceInitialState,
};

export const reducer = (state, action) =>
    combineReducers({
        bookingData: booking,
        objectData: object,
        profileData: profile,
        orderData: order,
        priceData: price,
        results,
        loginId: (init = {}) => init,
        deviceType: (init = {}) => init,
    })(state, action);
